export const setHasMutipleAddress = (data) => ({
    type: 'HAS_MULTIPLE_ADDRESS',
    data
});

export const resetZipcodeForm = (data) => ({
    type: 'SAVE_ZIPCODE_ENTERED_BY_USER',
    data
});

export const enableCheckAvailblity = (data) => ({
    type: 'ENABLE_CHECK_AVAILABILITY',
    data
});

export const disableCheckAvailblity = (data) => ({
    type: 'DISABLE_CHECK_AVAILABILITY',
    data
});

export const saveDeafultAddress = (data) =>({
    type: 'SAVE_DEFAULT_ADDRESS',
    data

})
export const disableCheckAvailblityButton = (data) => ({
    type: 'DISABLE_CHECK_AVAILABILITY_BUTTON',
    data
});
export const enableCheckAvailblityButton = (data) => ({
    type: 'ENABLE_CHECK_AVAILABILITY_BUTTON',
    data
});
export const setcmpCodeQueryParams = (data) =>({
    type: 'CMP_CODE_QUERY_PARAMS_AMEX_CARD',
    data
})

export const setcmpCodeQueryParamsWireless = (data) =>({
    type: 'CMP_CODE_QUERY_PARAMS_WIRELESS',
    data
})

export const setBannerInfo = (data) => ({
    type: 'SET_BANNER_INFO',
    data
});

export const setNewAddressFlow = (data) => ({
    type: 'SET_NEW_ADDRESS_FLOW',
    data
});

export const setExistingCustomer = (data) => ({
    type: 'IS_EXISTING_CUSTOMER',
    data
});
export const hasPendingOrder = (data) => ({
    type: 'HAS_PENDING_ORDER',
    data
});


export const setAddressInfo = (data) => ({
    type: 'SET_ADDRESS_INFO',
    data
});

export const redirectLBOPage = (message) => ({
    type: 'REDIRECT_TO_LBO',
    message
});

export const getChatInfo = (params) => ({
    type: 'GET_CHAT_INFO',
    params,
})
export const showSpinner = (data) => ({
    type: 'TOGGLE_LOADING_SPINNER',
    data,
})

export const resetDoLoopFlags = () => ({
    type: 'RESET_DOLOOP_FLAGS'
});

export const resetCheckoutFlags = () => ({
    type: 'RESET_CHECKOUT_FLAGS'
});

export const checkAvailAPI = (data) => ({
    type: 'CHECK_AVAIL_API',
    data
});

export const setEmptyUnitsError = (data) => ({
    type: 'SET_EMPTY_UNITS_ERROR',
    data
});

export const setBaseAddrError = (data) => ({
    type: 'SET_BASE_ADDR_UNIT_ERROR',
    data
});

export const setDontShowUnit = (data) => ({
    type: 'SET_DONT_SHOW_LIVE_UNIT',
    data
});

export const setCheckAvailabilityClicked = (data) => ({
    type: 'SET_CHECKAVAILABILITY_CLICKED',
    data
});
export const multipleAddrSelectionsWithId = (data) => ({
    type: 'POST_MULTIPLEADDR_SEL_WITH_ID',
    data
});

export const postUIEventLog = (data) => ({
    type: 'POST_EVENT_LOGGING',
    data
});

export const setCityAndState = (data) => ({
    type: 'SAVE_CITY_AND_STATE',
    data: data
});

export const getLqPageAds = (data) => ({
    type: 'GET_LQ_PAGE_ADS',
    data
})

export const redirectionHandler = (data) => ({
    type: 'REDIRECTION_HANDLER',
    data: data
});

export const getQulaificationDetails = (data) => ({
    type: 'GET_QUALIFICATION_DETAILS',
    data: data
});

export const SubmitIdeForm = (params,history) => ({
    type: 'SUBMIT_IDE_FORM',
    data: params,
    history
});

export const setRedirectedFrom = (data) => ({
    type: 'SET_REDIRECT_FROM',
    data
});

export const saveTheAddressEnteredDuringAddressValidation = (data) =>({
    type:"SAVE_ADDRSS_ENTERED_DURING_INITIAL",
    data: data,
})
export const setBannerId=(data) =>({
    type:"SET_BANNER_ID",
    data: data,
})
export const saveTheAutoPayAddress=(data) =>({
    type:"SAVE_AUTOPAY_ADDRESS",
    data: data,
})
export const checkAvailAPIVcg = (data) => ({
    type: 'CHECK_AVAIL_API_VCG',
    data
});